<script lang="ts">
  /**
   * The sensitive-data category chip: a rounded pill in the category's colour, gray when the
   * category has none. Shared by the SDD page's "Filter by Category" dropdown and tree rows and the
   * ESD category search so all render the same chip.
   */
  import type { HTMLAttributes } from "svelte/elements";
  import { cn } from "$utils/ui";

  interface Props extends HTMLAttributes<HTMLSpanElement> {
    label: string;
    /** The category colour; the chip falls back to gray when it is missing. */
    color?: string | null;
  }

  let { label, color, class: className, ...rest }: Props = $props();
</script>

<span
  class={cn(
    "inline-flex items-center rounded-full px-2.5 py-0.5 text-sm font-medium border whitespace-nowrap",
    !color && "bg-gray-100 border-gray-300",
    className,
  )}
  style={color ? `background-color: ${color};` : ""}
  {...rest}
>
  {label}
</span>
